import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeadManager from '@/components/base/HeadManager';
import HeroSection from './components/HeroSection';
import CategoryNav from './components/CategoryNav';
import FeaturedComics from './components/FeaturedComics';
import LatestUpdates from './components/LatestUpdates';
import PopularRanking from './components/PopularRanking';

export default function Home() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '香香漫画',
    url: 'https://xiangxiangmanga.com',
    description: '香香漫画提供免费漫画全集，香香漫画大全免费，香香漫画全集免费，香香漫画免费看，下拉式阅读，好看的漫画免费追更，海量资源。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://xiangxiangmanga.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <HeadManager
        title="香香漫画 - 香香漫画大全免费 香香漫画全集免费 香香漫画免费看 | 香香漫画免费下拉"
        description="香香漫画提供免费漫画全集，香香漫画大全免费，香香漫画全集免费，香香漫画免费看，下拉式阅读，好看的漫画免费追更，海量资源。香香漫画为您带来最优质的免费漫画阅读体验。"
        keywords="香香漫画,香香漫画大全免费,香香漫画全集免费,香香漫画免费看,香香漫画免费下拉,免费漫画全集,下拉式,好看的漫画,追更,在线阅读,漫画大全"
        canonical="https://xiangxiangmanga.com/"
        scripts={[{ type: 'application/ld+json', content: JSON.stringify(schema) }]}
      />

      <Navbar />
      <main>
        <HeroSection />
        <CategoryNav />
        <FeaturedComics />
        <LatestUpdates />
        <PopularRanking />
      </main>
      <Footer />
    </>
  );
}